module.exports = __webpack_public_path__ + "media/images/setting/icon1-603a39148ec67a627d4b8db31311ba9d.svg";